import React from 'react'
import { useField } from 'formik'
import { DocumentUpload } from 'components/DocumentUpload'
import { FormControl, FormControlProps, FormErrorMessage } from '@chakra-ui/react'
import { DropzoneOptions } from 'react-dropzone'
import { FormLabel } from './FormLabel'

type Props = {
  name: string
  label?: string
  placeholder?: string
  options?: DropzoneOptions
} & FormControlProps

export function DocumentUploadField({ name, label, placeholder, options, ...props }: Props) {
  const [, meta, helpers] = useField(name)

  return (
    <FormControl isInvalid={!!meta.error && meta.touched} {...props}>
      {label && <FormLabel htmlFor={name}>{label}</FormLabel>}
      <DocumentUpload
        placeholder={placeholder}
        options={options}
        onDataURL={(dataURL) => helpers.setValue(dataURL)}
        onClear={() => helpers.setValue('')}
      />
      <FormErrorMessage>{meta.error}</FormErrorMessage>
    </FormControl>
  )
}
